import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.modelSettings;

const modelSettingsData = createSelector([selector], (state) => state);

export default {
  modelSettingsData
};
